<template>
  <div id="tiposProductos">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="TIPOS DE PRODUCTO" color="primary darken-4" dark>
            <div slot="widget-content">
              <div>
                <v-btn
                  color="success"
                  dark
                  fab
                  small
                  slot="activator"
                  @click="abrirDialogNuevoProducto"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
                <form-tipo-producto
                  :tipoProducto="tipoProducto"
                  ref="dialogTipoProducto"
                  @onTipoProductoAdded="onTipoProductoAdded"
                  @onTipoProductoUpdated="onTipoProductoUpdated"
                ></form-tipo-producto>
              </div>

              <v-layout row wrap>
                <v-flex lg6 md12 sm12 xs12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text class="pa-0">
                      <template>
                        <v-data-table
                          :headers="headers"
                          :items="tiposProducto"
                          :search="search"
                          :rows-per-page-items="[
                            10,
                            25,
                            50,
                            { text: 'Todos', value: -1 },
                          ]"
                          class="elevation-1 table-styling"
                          item-key="tipoProductoId"
                        >
                          <template slot="items" slot-scope="props">
                            <td>
                              <v-icon color="primary">album</v-icon>
                            </td>
                            <td>
                              T{{ zeroFill(props.item.tipoProductoId, 3) }}
                            </td>
                            <td>{{ props.item.descripcion }}</td>
                            <td class="text-xs-right">
                              <v-btn
                                flat
                                icon
                                color="grey"
                                @click="
                                  getTipoProducto(props.item.tipoProductoId)
                                "
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <v-btn
                                flat
                                icon
                                color="grey"
                                :loading="$store.state.loadingDelete.show"
                                @click="
                                  deleteTipoProducto(props.item.tipoProductoId)
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                          </template>
                          <v-alert
                            slot="no-results"
                            :value="true"
                            color="error"
                            icon="warning"
                            outline
                            >La búsqueda para "{{ search }}" no encontró
                            registros</v-alert
                          >
                        </v-data-table>
                      </template>
                      <v-divider></v-divider>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formTipoProducto from "./FormTipoProducto";
import tipoProductoService from "@/services/tipoProductoService";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    VWidget,
    formTipoProducto,
    confirm,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "", align: "center", sortable: false },
        {
          text: "ID",
          align: "left",
          value: "tipoProductoId",
          visibility: "hidden-lg-only",
        },
        { text: "TIPO PRODUCTO", align: "center", value: "descripcion" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      tiposProducto: [],
      tipoProducto: {
        tipoProductoId: 0,
        descripcion: "",
      },
    };
  },
  mounted() {
    this.getTiposProducto();
  },
  methods: {
    abrirDialogNuevoProducto() {
      this.$store.state.tituloForm = "AGREGAR TIPO PRODUCTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogTipoProducto.resetForm();
      this.$refs.dialogTipoProducto.openDialog();
    },
    getTiposProducto() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      tipoProductoService
        .getAll()
        .then((result) => {
          self.tiposProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getTipoProducto(tipoProductoId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;
      tipoProductoService
        .get(tipoProductoId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR TIPO PRODUCTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";

          self.$refs.dialogTipoProducto.resetForm();
          self.tipoProducto = result;
          self.$refs.dialogTipoProducto.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteTipoProducto(id) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR TIPO PRODUCTO",
          "¿Estás seguro de eliminar el tipo producto seleccionado?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            tipoProductoService
              .delete(id)
              .then((result) => {
                var i = this.tiposProducto.findIndex(
                  (obj) => obj.tipoProductoId == id
                );
                self.tiposProducto.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Tipo producto eliminado con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                console.log(e);
                self.operationFailed(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onTipoProductoAdded(tipoProducto) {
      this.tiposProducto.push(tipoProducto);
    },
    onTipoProductoUpdated(tipoProducto) {
      var i = this.tiposProducto.findIndex(
        (obj) => obj.tipoProductoId == tipoProducto.tipoProductoId
      );
      this.tiposProducto.splice(i, 1, tipoProducto);
    },
  },
};
</script>

<style>
thead tr th {
  background-color: #00202c;
  color: white !important;
  max-height: 15px;
}
thead tr th i {
  color: white !important;
}
</style>
